export default "<div class=\"widget\">\r\n    <app-assignee-time-records [assignee]=\"assignee\"></app-assignee-time-records>\r\n</div>\r\n"